export default __webpack_public_path__ + "static/media/2.fa0b8ce6.jpeg";